module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#action",
      toString: function () {
        return this.url;
      }
    }